// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"BreadCrumbs_breadcrumbs_9e-8i"};